import { microCopy } from "@bmi-digital/dxb-microcopies";
import Button from "@bmi-digital/components/button";
import React from "react";
import { CONTINGENCY_PERCENTAGE_TEXT } from "../../calculation/constants";
import SelectedRoof from "../selected-roof";
import { useSiteContext } from "../../../Site";
import { Container, ContingencyText, classes } from "./ResultsHeader.styles";
import type { DimensionsValues, RoofV2 as Roof } from "../../types/roof";

type Props = {
  roof: Roof;
  dimensions: DimensionsValues;
  isHubSpotFormAvailable: boolean;
};

const ResultsHeader = (props: Props) => {
  const { getMicroCopy } = useSiteContext();

  return (
    <Container>
      <SelectedRoof roof={props.roof} dimensions={props.dimensions} />
      <ContingencyText
        data-testid="contingency-text"
        className={
          props.isHubSpotFormAvailable ? undefined : classes.hasBottomMargin
        }
      >
        {getMicroCopy(microCopy.RESULTS_SUBTITLE, {
          contingency: CONTINGENCY_PERCENTAGE_TEXT
        })}
      </ContingencyText>
      {!props.isHubSpotFormAvailable ? (
        <Button
          data-testid="print-calculation-report"
          gtm={{
            id: "rc-solution",
            action: "selected",
            label: getMicroCopy(microCopy.RESULTS_DOWNLOAD_PDF_LABEL)
          }}
          href="#print-calculations-report"
        >
          {getMicroCopy(microCopy.RESULTS_DOWNLOAD_PDF_LABEL)}
        </Button>
      ) : undefined}
    </Container>
  );
};

export default ResultsHeader;
